import { render, staticRenderFns } from "./HotRoute.vue?vue&type=template&id=01ede47a&scoped=true&"
import script from "./HotRoute.vue?vue&type=script&lang=js&"
export * from "./HotRoute.vue?vue&type=script&lang=js&"
import style0 from "./HotRoute.vue?vue&type=style&index=0&id=01ede47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ede47a",
  null
  
)

export default component.exports